import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';

export const FolderGrid = (props) => {
  const { callbacks, folders = [] } = props;
  const { handleSelectFolder } = callbacks;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '12px',
      }}
    >
      {folders?.map((folder) => (
        <Card
          key={folder.id}
          onClick={() => handleSelectFolder(folder)}
          sx={{
            backgroundColor: '#ecf3fb',
            boxShadow: 'none',
            borderRadius: '8px',
          }}
        >
          <CardActionArea>
            <CardContent
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '10px',
                minWidth: 0,
              }}
            >
              <FolderOpenOutlinedIcon sx={{ mr: 1, color: '#9e9e9c' }} />
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: '400',
                  flex: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  color: '#3d3b3c',
                }}
              >
                {folder.name}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </Box>
  );
};
